import { render } from "./Revealer.vue?vue&type=template&id=4de95fdd&scoped=true&ts=true"
import script from "./Revealer.vue?vue&type=script&lang=ts"
export * from "./Revealer.vue?vue&type=script&lang=ts"

import "./Revealer.vue?vue&type=style&index=0&id=4de95fdd&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de95fdd"]])

export default __exports__